<template>
  <Popover ref="popover" :showHeader="true" :headerTitle="title" sizeClass="popover-medium">
    <LoadingPanel ref="loadingPanel" />

    
  </Popover>
</template>

<script>
import Popover from '@/components/popover'
export default {
  name: 'MapTaskPopover',
  components: {
    Popover
  },
  data() {
    return {
      taskId: null,
      task: {}
    }
  },
  computed: {
    title() {
      if(this.task.name)
        return `Task: ${this.task.name}`
      return 'Task'
    }
  },
  methods: {
    displayFromElement(element, taskInfo) {
      this.$refs.popover.displayFromElement(element)

      // Reset
      this.task = {}
      this.taskId = taskInfo.id

      this.requestData()
    },
    requestData() {
      this.$refs.loadingPanel.startLoading()

      this.$apiService.tasksService.getTask(this.taskId)
      .then(response => {
        this.task = response.data
      })
      .catch(err => {
        this.$refs.loadingPanel.setError('Error loading task', err)
      })
      .finally(() => {
        this.$refs.loadingPanel.finishedLoading()
      })

    }
  }
}
</script>